import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { CauHinhBuoc } from './cau-hinh-buoc';
@Injectable()
export class CauHinhBuocService {

    controller:string = 'XL_Buoc_KetQua';
    constructor(private http: Http) { }
    
    GetList(idBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +this.controller+ "/GetList?idBuoc=" + idBuoc, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:CauHinhBuoc) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Delete(item:CauHinhBuoc) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Delete', item, { headers: headers }).map(resp => resp.json());
    }
    luu_BuocThoiGianXuLy(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/luu_BuocThoiGianXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListNhom(idQuyTrinh:number, loaiNhom:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +this.controller+ "/GetListNhom?idQuyTrinh=" + idQuyTrinh + "&loaiNhom=" + loaiNhom, { headers: headers }).map(resp => resp.json());       
    }
    SaveNhomBuoc(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/SaveNhomBuoc', item, { headers: headers }).map(resp => resp.json());
    }
    GetListNhomBuoc(idBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +this.controller+ "/GetListNhomBuoc?idBuoc=" + idBuoc, { headers: headers }).map(resp => resp.json());       
    }
    DeleteNhom(item:CauHinhBuoc) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/DeleteNhom', item, { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/cau-hinh-buoc.service.ts